// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"167":"detail","177":"home"}[chunkId] || chunkId) + "." + {"38":"7268a5e9","41":"6f4ad5a9","97":"aa87bd60","167":"ff4a3008","177":"49ac0d4b","389":"c20a9b1b","659":"4d215eb6","734":"11fe947f","867":"1409e227","917":"07742964","941":"38de1131"}[chunkId] + ".js";
};